import { Component, OnInit } from '@angular/core';
import { PAGINA_HOME } from 'src/app/tools/URL';

@Component({
  selector: 'sem-permissao',
  templateUrl: './sem-permissao.component.html',
  styleUrls: ['./sem-permissao.component.css']
})
export class SemPermissaoComponent implements OnInit {

  urlHome = PAGINA_HOME;
  url = PAGINA_HOME;

  constructor() { }

  ngOnInit() {
  }

}
